import React from "react";
import { useUID } from "react-uid";

export default function Clipboard({ color, size = 24 }) {
  const id = useUID();
  const svgSize = size === "sm" ? 12 : 24;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={svgSize}
      height={svgSize}
      viewBox="0 0 24 24"
    >
      <defs>
        <path
          id={id}
          d="M16 19a1 1 0 0 1-1 1H3c-.551 0-1-.448-1-1V5c0-.551.449-1 1-1h1c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2h1c.552 0 1 .449 1 1v14zM6 2h6v2H6l-.001-.997L6 3l-.001-.004V2H6zm9 0h-1c0-1.103-.897-2-2-2H6C4.897 0 4 .897 4 2H3C1.346 2 0 3.346 0 5v14c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V5c0-1.654-1.346-3-3-3z"
        />
      </defs>
      <use
        fill={color}
        fillRule="evenodd"
        transform="translate(3 1)"
        xlinkHref={`#${id}`}
      />
    </svg>
  );
}
